"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.anti-hallucination.disabled': 'Funkcja anty-halucynacji nie jest dostępna w Twoim obecnym planie.',
};
